import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'translateField',
})

export class TranslateFieldPipe implements PipeTransform {
    private readonly translate = inject(TranslateService);

    public transform(_value: string, prefix: string, ...args: any[]): any {
        return translateField(this.translate, _value, prefix);
    }

}

export function translateField(
    translate: TranslateService,
    _value: string,
    prefix: string,
): string {
        if (!_value || !prefix) {
            return '';
        }
        const value = `${prefix}fields.${_value}`;

        let translated = translate.instant(value);
        if (translated == value) {
            translated = translate.instant(`fallbacks.${value.substring(value.lastIndexOf('.') + 1)}`);
        }

        return translated;
}
